import React from "react";

export default function WhyWe() {
  const VerticalDivider = () => (
    <div className="hidden md:block w-px h-20 bg-white mx-auto"></div>
  );

  return (
    <section className="relative w-full overflow-hidden bg-black text-white">
      <div className="mx-auto max-w-6xl py-12 px-4 sm:px-4">
        <div className="text-center mb-12 px-4 md:px-20 lg:px-32">
          
          <h1 
            className="
              mb-4 w-full
              font-uber text-[28px] font-bold leading-[36px] text-current
              sm:text-[32px] sm:leading-[40px]
              xl-custom:text-[36px] xl-custom:leading-[44px]
              transition duration-200 ease-in-out
            "
          >
            Why We Started Creating Playables?
          </h1>
          
          <p 
            className="
              max-w-4xl mx-auto
              font-uber text-base font-normal leading-normal text-white
            "
          >
            The decision to develop playables was driven by the need to boost engagement rates and provide users with an immersive brand experience. By integrating gamification elements, we aimed to:
          </p>
        </div>
        
        <div className="space-y-12">
          <div className="flex flex-col md:flex-row justify-center items-center gap-10 md:gap-0">
            <div className="flex flex-col items-center text-center w-full md:w-1/2 px-4">
              <div className="w-24 h-24 mb-4 rounded-full flex items-center justify-center">
                <img
                src="/uploads/CaseStudy/Asset 88.svg"
                className="w-full h-full object-contain" alt="Placeholder" />
              </div>
              <p 
                className="
                  mt-2 max-w-[14rem] mx-auto text-white
                  font-uber text-base font-normal leading-normal
                "
              >
                Increase user retention and session time
              </p>
              <div className="w-20 h-px bg-white mt-6 md:hidden"></div>
            </div>
            <VerticalDivider />
            <div className="flex flex-col items-center text-center w-full md:w-1/2 px-4">
              <div className="w-24 h-24 mb-4 rounded-full flex items-center justify-center">
                <img
                src="/uploads/CaseStudy/Asset 89.svg"
                className="w-full h-full object-contain" alt="Placeholder" />
              </div>
              <p 
                className="
                  mt-2 max-w-[14rem] mx-auto text-white
                  font-uber text-base font-normal leading-normal
                "
              >
                Improve brand recall and loyalty
              </p>
              <div className="w-20 h-px bg-white mt-6 md:hidden"></div>
            </div>
          </div>
          <div className="flex flex-col md:flex-row justify-center items-center gap-10 md:gap-0">
            <div className="flex flex-col items-center text-center w-full md:w-1/2 px-4">
              <div className="w-24 h-24 mb-4 rounded-full flex items-center justify-center">
                <img
                src="/uploads/CaseStudy/Asset 92.svg"
                className="w-full h-full object-contain" alt="Placeholder" />
              </div>
              <p 
                className="
                  mt-2 max-w-[14rem] mx-auto text-white
                  font-uber text-base font-normal leading-normal
                "
              >
                Enhance customer interaction with personalized content
              </p>
              <div className="w-20 h-px bg-white mt-6 md:hidden"></div>
            </div>
            <VerticalDivider />
            
            <div className="flex flex-col items-center text-center w-full md:w-1/2 px-4">
              <div className="w-24 h-24 mb-4 rounded-full flex items-center justify-center">
                <img 
                src="/uploads/CaseStudy/Asset 91.svg"
                className="w-full h-full object-contain" alt="Placeholder" />
              </div>
              <p 
                className="
                  mt-2 max-w-[14rem] mx-auto text-white
                  font-uber text-base font-normal leading-normal
                "
              >
                Drive conversions through a more interactive and enjoyable experience
              </p>
              <div className="w-20 h-px bg-white mt-6 md:hidden"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}